import React, { PropTypes, PureComponent } from 'react';
import Slider from 'react-slick';
import './Gallery.scss'
import Dropzone from 'react-dropzone'


class Slide extends PureComponent {
  static propTypes = {
    url: PropTypes.string.isRequired,
    surface: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.hanldeOnDrop = this.hanldeOnDrop.bind(this);
    this.state = {
      vizualization: null
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.url !== this.props.url
      || nextProps.surface !== this.props.surface
    ) {
      this.setState({vizualization: null})
    }
  }

  hanldeOnDrop(accepted, rejected) {
    if (accepted && accepted[0]) {
      var reader = new FileReader();
      reader.onload = (e) => this.setState({vizualization: e.target.result});
      reader.readAsDataURL(accepted[0]);
    }
  }

  renderDropzone() {
    return (
      <div className="dropzone">
        <Dropzone
          accept="image/jpeg, image/png, image/gif"
          style={{
            width: "100%",
            height: "100%",
          }}
          disableClick={true}
          ref={(node) => { this.dropzoneRef = node; }}
          onDrop={this.hanldeOnDrop}
        >
        </Dropzone>
        <button type="button" className="btn" onClick={() => { this.dropzoneRef.open() }}>
            <i className="fa fa-camera"/> Reklāmas vizualizācija
        </button> 
      </div>
    )
  }

  renderVizualization() {
    const { surface } = this.props;
    return <div className="vizualization" style={{transform: surface}} />
  }

  render() {
    const { url, surface } = this.props;
    const { vizualization } = this.state;
    return (
      <div className="slide-wrap">
        <img src={url} alt=""/>
        { surface && this.renderDropzone() }
        { vizualization && <div className="vizualization" style={{transform: surface, backgroundImage: `url(${vizualization})` }} />}
      </div>
    )
  }
}

export default class Gallery extends PureComponent {
  static propTypes = {
    images: PropTypes.array.isRequired,
  };

  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    };
    const { images } = this.props;
    return (
      <div className="gallery-wrap">
        <div className="gallery">
          <Slider {...settings}>
            {images.map((image, idx) => <div key={idx}><Slide {...image}/></div>)}
          </Slider>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Gallery/index.js